import React from 'react'
import { Sidebar, PaymentInfo } from '../../components'
import './Payment.css'

const Payment = () => {
  return (
    <>
   
      <Sidebar/>
      <PaymentInfo/>
  
    </>
  )
}

export default Payment
